import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('operations');
const type = createActionType('operations');

export const START_OPERATION = type('StartNew');
export const CANCEL_OPERATION = type('CancelEdit');
export const SELECT_OPERATION = type('SelectOperation');
export const ADD_OPERATION_TO_STACK = apiType('AddOperationToStack');
export const UPDATE_TRANSFORM_OPERATION = apiType('UpdateTransformOperation');
export const DELETE_TRANSFORM_OPERATION = apiType('DeleteTransformOperation');
export const OPEN_OPERATIONS_MENU = type('OpenOperationsMenu');
export const CLOSE_OPERATIONS_MENU = type('CloseOperationsMenu');
export const CLEAR_IDS = type('ClearIds');
export const CREATE_TRANSFORMATION = apiType('CreateTransformation');
